<div class="flex flex-col space-y-2">
    <div class="flex items-center space-x-4">
        <p class="font-medium !m-0">Company/Organization:</p>
        <app-organization-chip
            [match]="organizationMatch"
        ></app-organization-chip>
        @if (this.organizationMatch) {
            <app-hover-tooltip
                class="ml-2"
                [moreInfo]="true"
                [message]="infoText.OrgTypeInfo"
            ></app-hover-tooltip>
        }
    </div>
    <mat-form-field appearance="outline" class="w-full">
        <input
            title="Company/Organization name"
            matInput
            [ngModel]="organizationName"
            (ngModelChange)="onInputChange($event)"
            [matAutocomplete]="auto"
            [appRegexInput]="
                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
            "
        />
        <mat-hint
            align="end"
            class="text-primary-700 font-medium cursor-pointer text-sm"
            (click)="revertOrganizationNameChanges()"
            >Revert changes</mat-hint
        >
        <mat-autocomplete
            autoActiveFirstOption
            #auto="matAutocomplete"
            (optionSelected)="checkOrganizationNameMatches()"
        >
            @for (organization of filteredOrganizations; track organization) {
                <mat-option [value]="organization.name"
                    >{{ organization.name }} - {{ organization.city }},
                    {{ organization.state }}</mat-option
                >
            }
        </mat-autocomplete>
    </mat-form-field>
</div>
